import React, { JSX } from 'react'
import { useLocation, useParams } from 'react-router'
import { ChatOverlayManager, QuickOverlayManagerView } from 'components/chatOverlays/ChatOverlayManager'
import { useEventDetail } from 'hooks/useEventDetail'
import { eventSectionPath } from 'lib/paths'

export const ChatsPage = (): JSX.Element => {
  const { eventId = '', chatId } = useParams<{ eventId: string, chatId: string }>()
  const { pathname } = useLocation()
  const { event, refetchEvent, setEvent } = useEventDetail()
  const basePath = eventSectionPath(eventId, 'chats')
  let view: QuickOverlayManagerView = 'list'
  if (pathname.endsWith('/new')) view = 'create'
  else if (chatId !== undefined) view = { edit: chatId }
  return (
    <ChatOverlayManager
      view={view}
      basePath={basePath}
      backLabel='Back to chat overlays'
      scope={{ kind: 'stream', event, refetchEvent, setEvent }}
    />
  )
}
